// Anzeige-Nummern (Nachtrag zu PR #3).
//
// Bestellungen aus dem Shop tragen zwei Nummern: unsere Bestellnr
// (B-JJJJ-NNNN) und die Shop-Nummer. Am Telefon und auf dem Lieferschein
// nennt der Kunde die Shop-Nummer, deshalb fuehrt sie in der Anzeige —
// mit dem Praefix G- fuer Glomer, damit sie nicht mit unserer eigenen
// Nummerierung verwechselt wird.
//
// Wichtig: Das ist ausschliesslich Darstellung. Die interne Identitaet
// bleibt ueberall die Bestellnr — URLs, API-Aufrufe, Verlauf, QR-Codes.
// Sonst haetten wir zwei konkurrierende Schluessel (Prinzip 4).

type MitNummern = {
  bestellnr: string;
  shopify_order_number?: string | null;
};

/** "G-8801", oder null wenn es keine Shop-Nummer gibt. */
export function gNummer(b: MitNummern): string | null {
  const n = b.shopify_order_number;
  return n !== null && n !== undefined && n !== '' ? `G-${n}` : null;
}

/** Die Nummer, die im Vordergrund steht. */
export function anzeigeNummer(b: MitNummern): string {
  return gNummer(b) ?? b.bestellnr;
}

/**
 * Die Nummer, die zusaetzlich genannt wird — bei Shop-Bestellungen also
 * unsere eigene. Null, wenn es nur eine gibt.
 */
export function zweitNummer(b: MitNummern): string | null {
  return gNummer(b) !== null ? b.bestellnr : null;
}
